const PAGE_SIZE = 10;

/**
 * PaisaCX pager: "X–Y of Z" · Prev · N / M · Next
 *
 * sticky: pin to bottom of a flex column panel.
 * flush: bleed full width when parent has padding (tables with -mx).
 */
export default function AdminPager({
  page = 1,
  total = 0,
  pageSize = PAGE_SIZE,
  loading = false,
  onPage,
  testId = "admin-pager",
  emptyLabel = "No rows",
  sticky = false,
  flush = false,
}) {
  const totalPages = Math.max(1, Math.ceil((total || 0) / pageSize) || 1);
  const safePage = Math.min(Math.max(1, Number(page) || 1), totalPages);
  const from = total === 0 ? 0 : (safePage - 1) * pageSize + 1;
  const to = Math.min(safePage * pageSize, total);
  const btn = "rounded-md border border-border px-2.5 py-1 hover:text-foreground disabled:opacity-40";

  return (
    <div
      className={[
        "flex flex-wrap items-center justify-between gap-3 text-xs text-muted-foreground",
        sticky ? "mt-auto shrink-0 border-t border-border px-4 py-3" : "border-t border-border px-4 py-3",
        flush ? "-mx-5 border-t border-border px-5 pt-3" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      data-testid={testId}
    >
      <span className="num">
        {loading ? "Loading…" : total === 0 ? emptyLabel : `${from}–${to} of ${total}`}
      </span>
      <div className="flex shrink-0 items-center gap-1">
        <button
          type="button"
          className={btn}
          disabled={loading || safePage <= 1}
          onClick={() => onPage?.(safePage - 1)}
          data-testid={`${testId}-prev`}
        >
          Prev
        </button>
        <span className="num px-2" data-testid={`${testId}-label`}>
          {safePage} / {totalPages}
        </span>
        <button
          type="button"
          className={btn}
          disabled={loading || safePage >= totalPages}
          onClick={() => onPage?.(safePage + 1)}
          data-testid={`${testId}-next`}
        >
          Next
        </button>
      </div>
    </div>
  );
}

export { PAGE_SIZE };
